import { Identifiable, Event } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByResources } from "./resources";
import { isFilteredByTags } from "./projectsElementsTags";

function isEventFiltered(event: Identifiable<Event>, filter: Filter): boolean {
  return [isFilteredByResources, isFilteredByTags].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(event, filter),
    false,
  );
}

export { isEventFiltered };
